import { makeStyles } from "@material-ui/styles";
import { CELL_HEIGHTS, CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  root: {
    [ `--container-width` ]: ({ containerWidth }) => `${containerWidth}px`,
    marginLeft: -CELL_WIDTHS.DRAG_HANDLE,
    width: `calc(100% + ${CELL_WIDTHS.DRAG_HANDLE}px)`,
    height: "100%",
  },
  container: {
    width: ({ fullSectionActions }) => `calc(100% - ${(fullSectionActions ? CELL_WIDTHS.TITLE_LARGE : CELL_WIDTHS.TITLE_NORMAL) + CELL_WIDTHS.DRAG_HANDLE}px)`,
    height: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    position: "relative",
  },
  scrollButtonSpacer: {
    width: "100%",
    height: CELL_HEIGHTS.XXSMALL,
  },
}));

export default useStyle;
